/**
 * 用户端首页接口相关api
 */
import request from '@/utils/request'

/**
 * 获取首页banner图
 * @param query
 * @returns {*}
 */
export function listBanner(query) {
    return request({
        url: '/userClient/home/bannerList',
        method: 'get',
        params: query
    })
}

/**
 * 获取首页banner图
 * @param query
 * @returns {*}
 */
export function getImgList(slide) {
    return request({
        url: '/userClient/home/getImgList',
        method: 'get',
        params: {slide}
    })
}


/**
 * 获取产品展示信息
 * @returns {*}
 */
export function getProduct() {
    return request({
        url: '/userClient/home/getProduct',
        method: 'get',
    })
}

/**
 * 根据id具体产品展示信息
 * @param query
 * @returns {*}
 */
export function getProductById(product) {
    return request({
        url: '/userClient/home/getProductById',
        method: 'get',
        params: {product}
    })
}


/**
 * 获取产品展示信息
 * @returns {*}
 */
export function getJournalism() {
    return request({
        url: '/userClient/home/getJournalism',
        method: 'get',
    })
}

/**
 * 获取id具体新闻中心信息
 * @param query
 * @returns {*}
 */
export function getJournalismById(journalism) {
    return request({
        url: '/userClient/home/getJournalismById',
        method: 'get',
        params: {journalism}
    })
}

/**
 * 获取旗下品牌信息
 * @returns {*}
 */
export function getBrandList() {
    return request({
        url: '/userClient/home/getBrand',
        method: 'get',
    })
}

/**
 * 获取旗下品牌信息
 * @returns {*}
 */
export function getBrandById(brand) {
    return request({
        url: '/userClient/home/getBrandById',
        method: 'get',
        params: {brand}
    })
}

/**
 * 导航栏获取产品分类
 * @returns {*}
 */
export function getProductClassify() {
    return request({
        url: '/userClient/home/getProductClassify',
        method: 'get',
    })
}

/**
 * 导航栏获取产品分类下分类
 * @returns {*}
 */
export function getProductClassifyById(classify) {
    return request({
        url: '/userClient/home/getProductClassifyById',
        method: 'get',
        params: {classify}
    })
}

/**
 * 导航栏获取产品分类详情信息
 * @returns {*}
 */
export function getPortalCategoryDetailVoById(classify) {
    return request({
        url: '/userClient/home/getPortalCategoryDetailVoById',
        method: 'get',
        params: {classify}
    })
}

/**
 * 导航栏获取产品分类详情信息
 * @returns {*}
 */
export function selectArticleList(type,pageNum,pageSize) {
    return request({
        url: '/userClient/home/selectArticleList',
        method: 'get',
        params: {
            type:type,
            pageNum:pageNum,
            pageSize:pageSize
        }
    })
}

/**
 * 通过id获取文章详情信息
 * @returns {*}
 */
export function selectListByArticle(article,type) {
    return request({
        url: '/userClient/home/selectListByArticle',
        method: 'get',
        params: {
            article:article,
            type:type
        }
    })
}

/**
 * 获取集团配置信息
 * @returns {*}
 */
export function getGroupInfo(type) {
    return request({
        url: '/userClient/home/getGroupInfo',
        method: 'get',
        params: {type}
    })
}

/**
 * 获取集团配置信息
 * @returns {*}
 */
export function getGroupInfoById(id) {
    return request({
        url: '/userClient/home/getGroupInfoById',
        method: 'get',
        params: {id}
    })
}

/**
 * 签约球员信息
 * @returns {*}
 */
export function selectPlayerList() {
    return request({
        url: '/userClient/player/selectList',
        method: 'get',
    })
}

/**
 * 签约球员信息
 * @returns {*}
 */
export function selectListByPlayer(player) {
    return request({
        url: '/userClient/player/selectListByPlayer',
        method: 'get',
        params: {player}
    })
}

/**
 * 俱乐部加盟申请
 * @param formData
 * @returns {*}
 */
export function joinUsClub(formData) {
    return request({
        url: '/userClient/home/joinUsClub',
        method: 'post',
        data: formData
    })
}

/**
 * 器材店加盟申请
 * @param formData
 * @returns {*}
 */
export function joinUsApply(formData) {
    return request({
        url: '/userClient/home/joinUsApply',
        method: 'post',
        data: formData
    })
}

/**
 * 设计申请
 * @param formData
 * @returns {*}
 */
export function joinUsDesign(formData) {
    return request({
        url: '/userClient/home/joinUsDesign',
        method: 'post',
        data: formData
    })
}


